/**
 * Slug helpers for public saved-preview URLs.
 */

import { slugify } from '../export/generators.js';

const PREVIEW_SLUG_RE = /^[a-z0-9](?:[a-z0-9-]{4,78}[a-z0-9])$/;
const SUFFIX_BYTES = 8;
const SUFFIX_CHARS = 13;

function randomBytes(count) {
  const bytes = new Uint8Array(count);
  if (globalThis.crypto?.getRandomValues) {
    globalThis.crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < count; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  return bytes;
}

function bytesToBase36(bytes) {
  let value = 0n;
  for (const byte of bytes) {
    value = (value << 8n) | BigInt(byte);
  }
  return value.toString(36).padStart(SUFFIX_CHARS, '0').slice(-SUFFIX_CHARS);
}

export function generatePreviewSlug(projectName = 'preview') {
  const base = (slugify(projectName) || 'preview').slice(0, 60).replace(/-+$/g, '') || 'preview';
  const suffix = bytesToBase36(randomBytes(SUFFIX_BYTES));
  return `${base}-${suffix}`.slice(0, 80).replace(/-+$/g, '');
}

export function validatePreviewSlug(slug) {
  return PREVIEW_SLUG_RE.test(String(slug || ''));
}
